@if (campaign.statistics && chartHasValues) {
	<tui-axes [axisYLabels]="axisYLabels" [horizontalLines]="horizontalLines" axisY="none" class="chart">
		<div class="bar-container">
			@for (barValue of chartValue; let i = $index; track barValue) {
				<div @ifStateAnimation [style.height.%]="(barValue[i] / chartMax) * 100" class="bar-set">
					<tui-bar
						[value]="barValue"
						[class.dark]="config.themeType === 'dark'"
						[class.seen]="isSeenExist"
						class="bar-set__bar"
					>
					</tui-bar>
					@if (barValue[i] > 0) {
						<span class="bar-set__label">
							{{ (barValue[i] / campaign.statistics.total) * 100 | number: '1.0-2' }}%
						</span>
					}
				</div>
			}
		</div>
	</tui-axes>
	<div class="axis-x-labels">
		@for (label of axisXLabels; let i = $index; track i) {
			<div class="label">
				{{ label }}
				<h6 [class.tertiary]="chartValue[i][i] === 0">
					{{ chartValue[i][i] > 0 ? (chartValue[i][i] | number) : '—' }}
				</h6>
			</div>
		}
	</div>
} @else {
	<div class="stub">
		<tui-axes [horizontalLines]="0" axisY="none" class="stub-chart">
			<div class="stub-bar-container">
				@for (i of [].constructor(5); track i) {
					<div class="stub-bar"></div>
				}
			</div>
		</tui-axes>
		<div class="stub-chart-note">
			@let status = campaign.info.status;
			@if (
				status === CampaignStatus.SCHEDULED || status === CampaignStatus.IN_PROGRESS || status === CampaignStatus.PAUSED
			) {
				{{ 'campaigns.detailsReport' | translate }}
			} @else {
				{{ 'dashboard.noData' | translate }}
			}
		</div>
	</div>
}
